import React from 'react'

import {NoResults, ClearLink} from './NoResultRow.styles'

const NoResultRowComponent = ({api, i18n, headers, datasetWidth, events}) => {
  const filters = api.getFiltersAsList()
  const width = datasetWidth - 50

  return (
    <NoResults colSpan={headers.length}>
      {filters && filters.length > 0 &&
        <p style={{width}}>
          {i18n.noResultsFilters} <ClearLink onClick={events.handleClick} href='/'>{i18n.clearFilters}</ClearLink> {i18n.andTryAgain}
        </p>
      }
      {(!filters || filters.length < 1) &&
        <p style={{width}}>{i18n.noResults}</p>
      }
    </NoResults>
  )
}

export default NoResultRowComponent
